<footer class="adc-footer-right" *ngIf="type == 'right'" ngClass="{{ data?.customClass }}">
    <p>{{data?.text1 | translate}}</p>
    <p>{{data?.text2 | translate}}</p>
</footer>

<footer class="adc-footer-spacebetween" *ngIf="type == 'both'" ngClass="{{ data?.customClass }}">
    <p>{{data?.text1 | translate}}</p>
    <p>{{data?.text2 | translate}}</p>
</footer>